var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9317 5.72523L12.1421 5.30979L10.2718 0.908042C9.93534 0.106825 8.78742 0.106825 8.45096 0.908042L6.58065 5.31968L1.80096 5.72523C0.930127 5.79448 0.573877 6.88255 1.2369 7.45626L4.86867 10.6018L3.78013 15.2706C3.58221 16.1213 4.50252 16.7939 5.25461 16.3389L9.36138 13.866L13.4681 16.3488C14.2202 16.8038 15.1405 16.1312 14.9426 15.2805L13.8541 10.6018L17.4859 7.45626C18.1489 6.88255 17.8025 5.79448 16.9317 5.72523ZM9.36138 12.0163L5.64054 14.2617L6.63013 10.0281L3.34471 7.1793L7.67909 6.80342L9.36138 2.81711L11.0536 6.81331L15.3879 7.18919L12.1025 10.038L13.0921 14.2715L9.36138 12.0163Z",
    fill: "#5F46FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.9ab6ac3ecb0445eea3a5b0f6cfde27be.svg";
export { ForwardRef as ReactComponent };